<script setup>
import { computed } from 'vue'

const props = defineProps({
    content: {
        type: Object,
        required: true,
    },
    logoOverride: {
        type: Object,
        default: null,
    },
})

const logo = computed(() => props.logoOverride || props.content.logo)
</script>

<template>
    <div class="auth-brand-logo">
        <span class="auth-brand-logo__mark">
            <img
                v-if="logo?.type === 'image'"
                :src="logo.src"
                :alt="logo.alt"
            >
            <svg v-else width="28" height="28" viewBox="0 0 24 24" fill="none">
                <path
                    d="M2.2 15.8
                    C5.2 15.2 6.4 9.2 10.2 7.2
                    C13.2 5.6 17.2 6.4 18.8 9.1
                    C20 11.1 19.2 13.5 17.2 14.2
                    C15.6 14.8 14.4 13.8 14.8 12.6
                    C15.2 11.4 16.4 11.4 17.2 12
                    C16.6 10.1 14.1 9.6 12.4 10.6
                    C10.2 11.9 10.3 15.3 12.6 16.6
                    C15.3 18.2 18.2 15.4 21.8 15.8
                    C19.5 18.6 16.4 20 13.6 19.5
                    C10.8 19 9.3 16.7 7.2 16.2
                    C5.4 15.8 4 17.3 2.2 17.4
                    Z"
                    fill="currentColor"
                />
            </svg>
        </span>
        <span>{{ props.content.name }}</span>
    </div>
</template>

<style lang="scss" scoped>
.auth-brand-logo {
    display: flex;
    align-items: center;
    gap: 12px;
    color: #fff;
    font-size: 22px;
    font-weight: 800;

    &--mobile {
        color: #302424;
    }

    &__mark {
        width: 44px;
        height: 44px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 12px;
        border: 1px solid rgba(255, 255, 255, 0.2);
        background: rgba(141, 141, 141, 0.15);
        backdrop-filter: blur(8px);

        img {
            width: 28px;
            height: 28px;
            object-fit: contain;
        }
    }
}

@media only screen and (max-width: 575px) {
    .auth-brand-logo {
        font-size: 19px;

        &__mark {
            width: 40px;
            height: 40px;
        }
    }
}
</style>
